export const ItemTypes = {
    ELEMENTO_RML_UNSELECTED: 'elemento_rml_unselected',
    ELEMENTO_RML_SELECTED: 'elemento_rml_selected',
    AZIENDA: 'fpnet_azienda',
    TURNO: 'fpnet_turno',
    TURNO_PENCIL: 'fpnet_turno_pencil',
    TURNO_ERASER: 'fpnet_turno_eraser',
    GIUSTIFICATIVO: 'fpnet_giustificativo',
}
type TTypes = typeof ItemTypes;

export interface Tool {
    name: string,
    type: string,
    tooltip: string,
    icon: 'pencil' | 'eraser',
}